import {SpaceTrSpace, Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import Container = Phaser.GameObjects.Container;
import {ArenaLeague, BattleLog, LeagueDto} from "@/store/arena/types";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import TimeUtils from "@/utils/time-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import ResourceUtils from "@/utils/resource-utils";
import ArenaUtils from "@/utils/arena-utils";

export class LeagueStatusPanel extends Container {

    private readonly HEIGHT: number = 100 * CU.S;
    private readonly FONT_STYLE: string = "italic";

    constructor(scene: Scene, canvas: HTMLCanvasElement, currL: ArenaLeague, currP:number, bestL: ArenaLeague, bestP:number) {
        super(scene);

        this.height = this.HEIGHT;

        let y = canvas.height / 2 / CU.S - 235 ;
        let x = 15;

        let currentLeague = TextUtils.addTextAdvanced(scene, Tr('current.league') + ":", x + 130, y - 25,
            '#e5a63f', 16,  this.FONT_STYLE,  500, 'left', 2, Fonts.MYRIADPRO_REGULAR).setScale(1, 1).setOrigin(0, 0.5);
        currentLeague.setPadding({right:5})

        let currentLeagueName = TextUtils.addTextAdvanced(scene, ArenaUtils.getLeagueName(currL), x + 130, y,
            ArenaUtils.getLeagueColor(currL), 15,  this.FONT_STYLE,  500, 'left', 2, Fonts.MYRIADPRO_REGULAR).setScale(1, 1).setOrigin(0, 0.5);
        currentLeagueName.setPadding({right:5})
        currentLeagueName.alpha = 0.8;

        let currentPosition = TextUtils.addTextAdvanced(scene, Tr('position') + ": " + currP, x + 130, y + 25,
            ArenaUtils.getLeagueColor(currL), 15,  this.FONT_STYLE,  500, 'left', 2, Fonts.MYRIADPRO_REGULAR).setScale(1, 1).setOrigin(0, 0.5);
        currentPosition.setPadding({right:5})

        let bestLeague = TextUtils.addTextAdvanced(scene, Tr('best.league') + ":", x + canvas.width / 2 / CU.S + 90, y-22,
            '#e5a63f', 13,  this.FONT_STYLE,  500, 'left', 2, Fonts.MYRIADPRO_REGULAR).setScale(1, 1).setOrigin(0, 0.5);
        bestLeague.setPadding({right:5})

        let bestLeagueName = TextUtils.addTextAdvanced(scene, ArenaUtils.getLeagueName(bestL), x + canvas.width / 2 / CU.S + 90, y,
            ArenaUtils.getLeagueColor(bestL), 12,  this.FONT_STYLE,  500, 'left', 2, Fonts.MYRIADPRO_REGULAR).setScale(1, 1).setOrigin(0, 0.5);
        bestLeagueName.setPadding({right:5})
        bestLeagueName.alpha = 0.7;

        let bestPosition = TextUtils.addTextAdvanced(scene, Tr('position') + ": " + bestP, x + canvas.width / 2 / CU.S + 90, y + 22,
            ArenaUtils.getLeagueColor(bestL), 12,  this.FONT_STYLE,  500, 'left', 2, Fonts.MYRIADPRO_REGULAR).setScale(1, 1).setOrigin(0, 0.5);
        bestPosition.setPadding({right:5})
        bestLeagueName.alpha = 0.8;

        let currLeagueImg = SpriteUtils.addImage(scene, x + 75, y, Keys.ATLAS_LEAGUE, ArenaUtils.getLeagueImg(currL), 0.6);

        let bestLeagueImg = SpriteUtils.addImage(scene, x + canvas.width / 2 / CU.S + 55, y, Keys.ATLAS_LEAGUE, ArenaUtils.getLeagueImg(bestL), 0.45);
        bestLeagueImg.alpha = 0.3;

        let separator = SpriteUtils.addSprite(scene, x + canvas.width / 2 / CU.S+5, y + 50, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0.5, 0.5).setScale(0.8);
        let sepVertical = SpriteUtils.addImage(scene, x + canvas.width / 2 / CU.S+10, y, Keys.DIVIDER_VERTICAL, undefined, 1, 1.8);

        this.add([currentLeague, bestLeague, currentLeagueName, bestLeagueName, bestPosition, currentPosition, currLeagueImg, bestLeagueImg, separator, sepVertical]);

    }
}
